<script lang="ts">
	// Svelte
	import { onMount } from 'svelte';
	//Design system components
	import { Text } from '@Shelly/shelly-design-system';
	//Components
	import DeviceChartContainer from './DeviceChartContainer.svelte';
	import FullScreenChart from './FullScreenChart.svelte';
	import { getChartSensorName } from './chart_helper';
	import ChartTitle from './ChartTitle.svelte';
	import DeviceChart from './DeviceChart.svelte';
	import EvChargerLiveChart from '../XT1/EvCharger/EvChargerLiveChart.svelte';
	import EvChargerLivetimeEnergy from '../XT1/EvCharger/EvChargerLivetimeEnergy.svelte';
	import { getDefaultMatrix } from './chart_more_actions_helper';
	import DummyNetMeteringModal from '../Consumption/DummyNetMeteringModal.svelte';
	//Types
	import type { Device } from '../../types/Device';
	import type {
		ChartConfigInterface,
		ChartDataInterface,
		ChartStatisticInterface,
	} from '../../types/Chart';
	import type { ChartTimeType } from './chart_more_actions_helper';
	export let device: Device,
		deviceChartsConfig: ChartConfigInterface[],
		scrollToActiveElID: string = null,
		initialAddOnsLoad: boolean = false;

	type fullScreenDeviceChartType = {
		fullScreen?: boolean;
		fullScreenTarget?: HTMLElement;
	}[][];

	let statsData: Promise<{
		chartData: ChartDataInterface;
		chartStatistic: ChartStatisticInterface;
	}>[][] = getDefaultMatrix(deviceChartsConfig.length);

	let chartElement: DeviceChart[][] = getDefaultMatrix(deviceChartsConfig.length);

	let chartTime: ChartTimeType[][] = getDefaultMatrix(deviceChartsConfig.length);

	let dummyNetMetering = false;
	let dummyNetMeteringPopUp = false;
	let showNetMeteringModal = false;

	const getStorageKey = () => `dummyNetMeteringPopUp_${device.id}`;

	const handleNetMeteringToggle = () => {
		if (!dummyNetMeteringPopUp) {
			dummyNetMeteringPopUp = true;
			localStorage.setItem(getStorageKey(), JSON.stringify(true));
			showNetMeteringModal = true;
		}

		dummyNetMetering = !dummyNetMetering;
	};

	const createDeviceChartsList = (
		deviceChartsConfig: ChartConfigInterface[],
	): fullScreenDeviceChartType => {
		return deviceChartsConfig.map((config) => {
			return Array.from(Array(config.charts.length).keys()).map(() => ({
				fullScreen: null,
				fullScreenTarget: null,
			}));
		});
	};

	let fullScreenDeviceChartsList = createDeviceChartsList(deviceChartsConfig);

	onMount(() => {
		const stored = localStorage.getItem(getStorageKey());
		if (stored !== null) {
			dummyNetMeteringPopUp = JSON.parse(stored);
		}

		if (scrollToActiveElID != null) {
			const scrollElement = document.getElementById(`chart_${scrollToActiveElID}`);
			if (scrollElement) {
				setTimeout(
					() => scrollElement.scrollIntoView({ behavior: 'smooth' }),
					initialAddOnsLoad ? 500 : 100,
				);
				initialAddOnsLoad = false;
			}
		}
	});
</script>

{#if device?.category === 'charger'}
	<EvChargerLiveChart {device} />
{/if}

{#each deviceChartsConfig as chartsConfig, i}
	{#each chartsConfig?.charts as chartConfig, j}
		<FullScreenChart
			id={`chart_${chartConfig.id}`}
			class={deviceChartsConfig.length - 1 == i ? 'mb-s' : 'mb-m'}
			{device}
			chartElement={chartElement[i][j]}
			bind:statsData={statsData[i][j]}
			bind:chartTime={chartTime[i][j]}
			bind:chartConfig
			bind:fullScreen={fullScreenDeviceChartsList[i][j].fullScreen}
			bind:fullscreenTarget={fullScreenDeviceChartsList[i][j].fullScreenTarget}
			{dummyNetMetering}
			onNetMeteringToggle={handleNetMeteringToggle}
		>
			<ChartTitle
				slot="title"
				title={chartConfig.title || chartConfig.name}
				style={`text-indent:${fullScreenDeviceChartsList[i][j].fullScreen ? 64 : 32}px`}
			/>
			{#if chartConfig?.sensorID}
				<Text
					styleType="tiny"
					class="mb-s mr-xl text-center"
					style={`text-indent:${fullScreenDeviceChartsList[i][j].fullScreen ? 64 : 32}px`}
					noWrap
				>
					{getChartSensorName(chartConfig)}
				</Text>
			{/if}
			<DeviceChartContainer
				bind:chartElement={chartElement[i][j]}
				bind:statsData={statsData[i][j]}
				bind:chartTime={chartTime[i][j]}
				reqURL={chartsConfig.url}
				{chartConfig}
				{device}
				fullScreenDeviceChartObj={fullScreenDeviceChartsList[i][j]}
				{dummyNetMetering}
			/>
		</FullScreenChart>
	{/each}
{/each}

{#if device?.category === 'charger'}
	<EvChargerLivetimeEnergy {device} />
{/if}

<DummyNetMeteringModal bind:showNetMeteringModal />
